export default "<ul> \n    <li *ngFor=\"let breadcrumb of (breadcrumbs$ | async)\"> \n      {{ breadcrumb.label }} \n    </li> \n  </ul>";